import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useCallback } from "react";

export const DEFAULT_QUALIFICATION_RANKING = [
  "Lead Teacher",
  "Substitute Teacher",
  "Early Education Teacher",
  "Early Education Aide",
  "Teacher Assistant",
  "Paraprofessional",
  "RN Supervisor",
  "RN",
  "LVN / LPN Supervisor",
  "LVN",
  "LPN",
  "LVN / LPN",
  "CNA",
  "CHHA",
  "HHA",
  "CAREGIVER",
  "NURSE",
  "Janitor",
];
export interface HiringQualificationRanking {
  qualificationRanking: string[];
  getHighestRankingQualification: (qualifications: string[]) => string | undefined;
  sortQualificationsByRanking: (qualifications: string[]) => string[];
}

export function useHiringQualificationRanking(): HiringQualificationRanking {
  const qualificationRanking = useCbhFlag(CbhFeatureFlag.HIRING_QUALIFICATION_RANKING, {
    defaultValue: DEFAULT_QUALIFICATION_RANKING,
  });

  const getHighestRankingQualification = useCallback(
    (qualifications: string[]) => {
      if (qualifications.length === 0) {
        return undefined;
      }

      return (
        qualificationRanking.find((rankingQualification) =>
          qualifications.includes(rankingQualification)
        ) ?? qualifications[0]
      );
    },
    [qualificationRanking]
  );

  const sortQualificationsByRanking = useCallback(
    (qualifications: string[]) => {
      return [...qualifications].sort(
        (a, b) => qualificationRanking.indexOf(a) - qualificationRanking.indexOf(b)
      );
    },
    [qualificationRanking]
  );

  return { qualificationRanking, getHighestRankingQualification, sortQualificationsByRanking };
}
